import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { MRT_ColumnDef } from "material-react-table";
import ProductInfo from "./product-details/product-info";
import LastProcessorInfo from "./product-details/last-processor-info";
import AdditionalInfo from "./product-details/additional-info";
import RawMaterialInfo from "./product-details/raw-material-info";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import {
  IAdditionalInfo,
  ICertifiedProductDetails,
  ILastProcessorInfo,
  ITCProduct,
  ITcProductRawMaterialInformation,
  ITcProductStandardDetailsInformation,
  ITCRawMaterial,
  mapToPayload,
  payloadToMap,
} from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import _ from "lodash";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import TcproductStandard from "./product-details/tc-standard-details";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  getShipmentIdsByNumbers,
  getShipmentIdsByProductId,
  mapBasicProductPayload,
  mapProductData,
  mapProductDataToStepData,
  ProductShipmentResponse,
} from "./certified-products.model";
import { fetchProductaddDetails } from "./product-api";
import { ApiShipmentResponseItem } from "../shipments/shipments.model";
import { dtrackItService } from "../../../tc-service/dtrackit.service";
import zIndex from "@mui/material/styles/zIndex";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";
import ComponentCreationModal from "./component-creation.modal";
import ProductInfoComp, {
  ProductDerivedComponent,
} from "./product-details/product-info-comp";

/** Compute certified and non-certified weight totals from product derived components (same logic as ProductInfoComp). */
function getComponentWeightTotals(components: ProductDerivedComponent[]) {
  const certified = components.reduce(
    (sum, c) => sum + (Number(c.componentCertifiedWeight) || 0),
    0
  );
  const nonCertified = components.reduce(
    (sum, c) =>
      sum + (Number(c.componentCertifiedAndNonCertifiedWeight) || 0),
    0
  );
  return { certifiedWeight: certified, nonCertifiedWeight: nonCertified };
}

interface CertifiedProductsComponentsProps {
  onNextTab: () => Promise<void>;
}

const CertifiedProductsComponents: React.FC<
  CertifiedProductsComponentsProps
> = ({ onNextTab }) => {
  const isUpToFiveDecimals = (value: any) => {
    if (value === null || value === undefined || value === "") return false;
    return /^(0|[0-9]\d*|0\.\d{1,5}|[0-9]\d*\.\d{1,5})$/.test(
      String(value).trim()
    );
  };
  const formatFiveDecimals = (value: any) => {
    const numeric = Number(value ?? 0);
    if (Number.isNaN(numeric)) return "0.00";
    return numeric.toFixed(5);
  };
  const formatDynamicDecimals = (value: any) => {
    const numeric = Number(value ?? 0);
    if (Number.isNaN(numeric)) return "0.00";
    
    // For zero, show 0.00
    if (numeric === 0) return "0.00";
    
    // Format with 5 decimals then strip trailing zeros but keep at least 1 decimal
    let str = numeric.toFixed(5);
    str = str.replace(/0+$/, ''); // Remove trailing zeros
    if (str.endsWith('.')) str += '0'; // If ends with dot, add one zero back
    
    return str;
  };
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const [componentModalOpen, setComponentModalOpen] = useState(false);
  /** When set, open component modal in edit mode with this context (e.g. from detail panel Edit) */
  const [componentEditContext, setComponentEditContext] = useState<{
    componentId: string;
    productId: string;
    shipmentId: string;
    productNumber: string;
    shipmentNumber: string;
  } | null>(null);
  const [productDerivedComponents, setProductDerivedComponents] = useState<any[]>([]);
  const [addWithComponent, setAddWithComponent] = useState(true);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [apiShipmentsData, setAPIData] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [pendingSave, setPendingSave] = useState<any | null>(null);
  const [originalValue, setOriginalValue] = useState("");
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [getPreviousProductNo, setPreviousProductNo] = useState("");
  const { isRestrictPopUpSave, setRestrictPopUpSave, getTCStandardGOTS, isAdmin } =
    useTransactionCertificateStore();
  const [getEditExistingShipment, setEditExistingShipment] = useState({
    index: -1,
    value: "",
  });
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    replaceTableDatas,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("certified-products");
  const initTcProduct: ITCProduct = {
    tcProductShipmentNo: [], //'',
    // associatedShipmentNo: '',
    tcProductNo: "",
    tcProductCategoryCode: "",
    tcProductProductionDate: "",
    tcNetShippingWeight: "",
    tcProductSupplementaryWeight: "",
    tcProductOrderNo: [],
    tcProductArticleNo: "",
    tcProductNumberOfUnits: "",
    tcProductUnitsMetric: "",
    tcProductInfoAssociatedTc: "",
    // tcProductCertifiedWeight: '',
    // tcProductStandardLabelGrade: '',
    tcProductOrder: "",
    tcProductCategoryUserSpecificTerm: "",
    tcProductDetailCode: "",
    tcProductDetailUserSpecificTerm: "",
    tcProductAdditivesWeight: null,
    tcProductHasComponents: "false",
    tcProductCertifiedWeightTotal: 0,
    tcProductNonCertifiedWeightTotal: 0,
  };

  const initLastProcessorInfo: ILastProcessorInfo = {
    tcIsLastProcessorTECertitfied: "Y",
    tcProductLastProcessorCountry: "",
    tcProductLastProcessorLicenseNo: "",
    tcProductLastProcessorName: "",
    tcProductLastProcessorTeId: "",
  };

  const initAdditonalInfo: IAdditionalInfo = {
    tcProductInfoAdditional: "",
    tcProductInfoFabricWeightAndConstruct: "",
    tcProductInfoFabricWeightOfFinishedProduct: "",
    tcProductInfoFiberLength: "",
    tcProductInfoTrimsExcluded: "",
    tcProductInfoYarnCount: "",
    tcProductAdditives: [],
    tcProductAdditivesWeight: null,
  };
  const initStandardInfo: ITcProductStandardDetailsInformation[] = [];
  const initRawMaterialInfo: ITcProductRawMaterialInformation[] = [];
  const [shipmentData, setShipmentData] = useState<ApiShipmentResponseItem[]>(
    []
  );
  const [tableData, setTableData] = useState<ProductShipmentResponse[] | null>(null);
  const [stepData, setStepData] = useState({
    productInfo: initTcProduct,
    standardInfo: initStandardInfo,
    lastProcessorInfo: initLastProcessorInfo,
    additionalInfo: initAdditonalInfo,
    rawMaterialInfo: initRawMaterialInfo,
  });

  const [isDeleteOnly, setDeleteOnly] = useState(false);

  const productInfoRef = useRef<any>(null);
  const lastProcessorInfoRef = useRef<any>(null);
  const additionalInfoRef = useRef<any>(null);
  const rawMaterialInfoRef = useRef<any>(null);
  const toggleDrawer = () => {
    setActiveStep(0);
    if (drawerOpen) {
      setStepData({
        productInfo: initTcProduct,
        standardInfo: initStandardInfo,
        lastProcessorInfo: initLastProcessorInfo,
        additionalInfo: initAdditonalInfo,
        rawMaterialInfo: initRawMaterialInfo,
      });
      setProductId(null);
      setShipmentId(null);
      setPendingSave(null);
      setEditingIndex(-1);
    }
    setRestrictPopUpSave(false);
    setDrawerOpen((prev) => !prev);
    if (drawerOpen) setProductDerivedComponents([]);
  };
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const formRefs = [
    productInfoRef,
    additionalInfoRef,
    lastProcessorInfoRef,
    additionalInfoRef,
    rawMaterialInfoRef,
  ];
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [productId, setProductId] = useState<string | null>(null);
  const [deleteShpId, setDeleteShpId] = useState<string | null>(null);
  const [deleteShpNo, setDeleteShpNo] = useState<string | null>(null);
  const [tcProductNo, setTcProductNo] = useState<string | null>(null);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const originalProductNoRef = useRef<string | null>(null);
  const originalShipmentNoRef = useRef<string | null>(null);
  const [shipmentId, setShipmentId] = useState<string | null>(null);
  const [shipmentNo, setShipmentNo] = useState<string | null>(null);
  const [productCategory, setProductCategory] = useState([]);
  const [totalCertifiedWeight, setTotalCertifiedWeight] = useState<number>(0);
  const [disableOnEdit, setDisableOnEdit] = useState<boolean>(false);
  const [editWithComponentConfirmOpen, setEditWithComponentConfirmOpen] =
    useState(false);
  const [pendingComponentFormValues, setPendingComponentFormValues] =
    useState<any | null>(null);
  // Snapshot of product data used for the first "Save & Add Components"
  // in create-with-components flow so we can detect changes and reset
  // correctly when the product is cancelled/deleted.
  const createdProductSnapshotRef = useRef<any | null>(null);
  const {
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  // const modalAttributes = useApi();
  const { loading: nextLoader, executeGet: executeShipment } = useApi();
  const { notify } = useNotification();
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [saveAndAddComponentsLoading, setSaveAndAddComponentsLoading] = useState(false);
  const [discardChangesConfirmOpen, setDiscardChangesConfirmOpen] = useState(false);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const [dashboardLoading, setDashboardLoading] = useState<boolean>(true);
  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };

  useEffect(() => {
    const hasComponents =
      addWithComponent && productDerivedComponents.length > 0;
    const weightTotals = hasComponents
      ? getComponentWeightTotals(productDerivedComponents)
      : { certifiedWeight: 0, nonCertifiedWeight: 0 };
    setStepData((prev) => ({
      ...prev,
      productInfo: {
        ...prev.productInfo,
        tcProductHasComponents: hasComponents ? "true" : "false",
        tcProductCertifiedWeightTotal: weightTotals.certifiedWeight,
        tcProductNonCertifiedWeightTotal: weightTotals.nonCertifiedWeight,
      },
    }));
  }, [addWithComponent, productDerivedComponents]);

  const shipmentFormData = async () => {
    try {
      const response = await executeShipment(TCAppConfig.GET_SHIPMENTS_LIST, {
        tcId: TE_ID,
      });
      setShipmentData(response?.data.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const steps = [
    {
      label: addWithComponent ? "Basic Product Information" : "Product Information",
      content: (
        <ProductInfo
          formRef={productInfoRef}
          productData={stepData.productInfo}
          setProductData={(data) => handleDataUpdate("productInfo", data)}
          shipmentId={shipmentId || ""}
          addWithComponent={addWithComponent}
        />
      ),
    },
    ...(addWithComponent
      ? [
          {
            label: "Product Information",
            content: (
              <ProductInfoComp
                shipmentNumber={
                  Array.isArray(stepData.productInfo.tcProductShipmentNo)
                    ? stepData.productInfo.tcProductShipmentNo[0] ?? ""
                    : String(stepData.productInfo.tcProductShipmentNo ?? "")
                }
                productNumber={stepData.productInfo.tcProductNo ?? ""}
                components={productDerivedComponents}
                backendTotals={
                  (stepData.productInfo as any).totalNetShippingWeight != null ||
                  (stepData.productInfo as any).totalCertifiedWeight != null ||
                  stepData.productInfo.tcProductCertifiedWeightTotal != null
                    ? {
                        totalNetShippingWeight: (stepData.productInfo as any).totalNetShippingWeight,
                        totalSupplementaryWeight: (stepData.productInfo as any).totalSupplementaryWeight,
                        totalDerivedWeight: (stepData.productInfo as any).totalDerivedWeight,
                        totalCertifiedWeight: (stepData.productInfo as any).totalCertifiedWeight ?? stepData.productInfo.tcProductCertifiedWeightTotal,
                        totalNonCertifiedWeight: (stepData.productInfo as any).totalNonCertifiedWeight ?? stepData.productInfo.tcProductNonCertifiedWeightTotal,
                      }
                    : undefined
                }
                backendRawMaterialInfo={
                  Array.isArray(stepData.rawMaterialInfo) && stepData.rawMaterialInfo.length > 0
                    ? stepData.rawMaterialInfo
                    : undefined
                }
              />
            ),
          },
        ]
      : [
          {
            label: "Raw Material Information",
            content: (
              <RawMaterialInfo
                rawMaterialInfoData={stepData.rawMaterialInfo}
                setRawMaterialInfoData={(data) =>
                  handleDataUpdate("rawMaterialInfo", data)
                }
              />
            ),
          },
        ]),
    {
      label: "Last Processor Information",
      content: (
        <LastProcessorInfo
          formRef={lastProcessorInfoRef}
          lastProcessorData={stepData.lastProcessorInfo}
          setLastProcessorData={(data) =>
            handleDataUpdate("lastProcessorInfo", data)
          }
        />
      ),
    },
    {
      label: "Additional Information",
      content: (
        <AdditionalInfo
          formRef={additionalInfoRef}
          additionalInfoData={stepData.additionalInfo}
          productCategoryCode={stepData.productInfo.tcProductCategoryCode}
          productDetailCode={stepData.productInfo.tcProductDetailCode}
          setAdditionalInfoData={(data) =>
            handleDataUpdate("additionalInfo", data)
          }
          addWithComponent={addWithComponent}
        />
      ),
    },
    {
      label: "Product Standard Information",
      content: (
        <TcproductStandard
          TE_ID={TE_ID}
          standardData={stepData.standardInfo} // Pass the array
          productData={stepData.productInfo}
          rawMaterialData={stepData.rawMaterialInfo}
          rawMaterialInfoData={stepData.rawMaterialInfo}
          productId={productId ?? ""}
          shipmentId={shipmentId ?? ""}
          setStandardData={(data) => handleDataUpdate("standardInfo", data)}
          setTotalCertifiedWeight={setTotalCertifiedWeight}
          disableOnEdit={disableOnEdit}
          setDisableOnEdit={setDisableOnEdit}
        />
      ),
    },
  ];

  const getProductCategory = async () => {
    try {
      const result: any = await dtrackItService.getProductCategory();

      Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

      const prdtDetails = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
      return prdtDetails;
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  const fetchProductDetails = async () => {
    try {
      setDashboardLoading(true);
      const response: any = await executeGet(
        TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_LIST,
        { 
          tcId: TE_ID,
          limit: pagination?.pageSize,
          offset: pagination?.pageIndex * pagination?.pageSize
        }
      );

      let result = response.data;
      let getProductCategoriesStore = await getProductCategory();

      result.response = result.response.map((res: any) => {
        return {
          ...res,
          tcProductCategoryCodeDescription:
            getProductCategoriesStore.find(
              (option: any) => option.value === res.tcProductCategoryCode
            )?.label || "",
          tcCertifiedWeight: res.tcProductCertifiedWeightTotal ?? 0,
          tcNonCertifiedWeight: res.tcProductNonCertifiedWeightTotal ?? 0,
        };
      });

      setTableData(result.response);
      setAPIData(result.response);
      setRowCount(response?.data?.no_of_records);
      setDeleteSave(false);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    } finally {
      setDashboardLoading(false);
    }
  };

  /**
   * Refetches product detail (GET get-productandrawmaterial-info-new) and updates stepData
   * with backend-calculated totals and RM composition. Call after component save/delete
   * or when navigating to the Product Information step.
   */
  const refetchProductDetailForTotals = async () => {
    if (!TE_ID || !productId || !shipmentId) return;
    try {
      const res = await fetchProductaddDetails(
        executeGet,
        TE_ID,
        productId,
        shipmentId
      );
      const body = res?.data ?? res;
      const payload = body?.data ?? body;
      if (!payload?.tcProductInformation?.length) return;
      const product = payload.tcProductInformation[0];
      const productComponentTotals = payload.productComponentTotals;
      const netShippingWeight =
        productComponentTotals?.totalNetShippingWeight ??
        payload.tcNetShippingWeight ??
        0;
      const mapped = mapProductDataToStepData(product, netShippingWeight);
      const productInfoOverlay: Record<string, any> = { ...mapped.productInfo };
      if (productComponentTotals) {
        productInfoOverlay.totalNetShippingWeight =
          productComponentTotals.totalNetShippingWeight;
        productInfoOverlay.totalSupplementaryWeight =
          productComponentTotals.totalSupplementaryWeight;
        productInfoOverlay.totalDerivedWeight =
          productComponentTotals.totalDerivedWeight;
        productInfoOverlay.totalCertifiedWeight =
          productComponentTotals.totalCertifiedWeight;
        productInfoOverlay.totalNonCertifiedWeight =
          productComponentTotals.totalNonCertifiedWeight;
      }
      setStepData((prev) => ({
        ...prev,
        productInfo: { ...prev.productInfo, ...productInfoOverlay } as ITCProduct,
        standardInfo: (mapped.standardInfo ?? prev.standardInfo) as ITcProductStandardDetailsInformation[],
        lastProcessorInfo: (mapped.lastProcessorInfo ?? prev.lastProcessorInfo) as ILastProcessorInfo,
        additionalInfo: (mapped.additionalInfo ?? prev.additionalInfo) as IAdditionalInfo,
        rawMaterialInfo: (mapped.rawMaterialInfo ?? prev.rawMaterialInfo) as ITcProductRawMaterialInformation[],
      }));
    } catch (err) {
      console.error("Refetch product detail for totals failed:", err);
    }
  };

  const handleConfirmSave = async () => {
    try {
      if (!productId) {
        notify("No product selected for deletion", "error");
        return;
      }

      // If this is a product number edit (pendingSave set), just save with oldProductNo.
      if (pendingSave) {
        const oldProductNoParam = tcProductNo ?? "";
        delete pendingSave.productId;
        await handleSave(pendingSave, oldProductNoParam);
        setPendingSave(null);
        setDialogOpen(false);
        setProductId(null);
        fetchProductDetails();
        notify("Successfully processed", "success");
        return;
      }

      // Otherwise this is a pure delete action – keep existing delete behaviour.
      const res = await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.product,
        tcId: TE_ID,
        productId: productId,
        shipmentId: deleteShpId ?? shipmentId,
        shipmentNo: encodeURIComponent(
          encodeURIComponent(deleteShpNo ?? shipmentNo ?? "")
        ),
        productNo: encodeURIComponent(encodeURIComponent(tcProductNo ?? "")),
      });

      if (res?.status === 200) {
        setDialogOpen(false);
        setProductId(null);
        fetchProductDetails();
        notify("Successfully processed", "success");
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const handleDeleteSaveData = async () => {
    if (TE_ID) {
      if (!isDeleteOnly && getDeleteSave()) {
        const userFilledValues = getCurrentFormValues();
        updateTableRowbyIndex(editingIndex, userFilledValues);
      } else if (isDeleteOnly && !getDeleteSave()) {
        removeTableRowbyIndex(editingIndex);
        const deletedData = data.filter((item, index) => {
          index !== editingIndex;
        });
        setData(deletedData);
        setEditingIndex(-1);
      }

      const certifiedPrdtData: any = getCurrentTableData();
      const totalNetShippingWeight = certifiedPrdtData.reduce(
        (sum: any, item: any) => {
          return sum + parseFloat(item.tcNetShippingWeight || 0);
        },
        0
      );
      const payload = mapToPayload(
        certifiedPrdtData,
        TE_ID,
        totalNetShippingWeight
      );
      // TODO Commenetexd for demo
      setDeleteSave(false);
      setEditSave(false);
      const result: any = await executePost(
        TCAppConfig.CERTIFIED_PRODUCT_DETAILS_ENDPOINT,
        payload
      );
      if (result.status == 200) {
        notify("Saved Successfully", "success");
        if (!isDeleteOnly) toggleDrawer();

        setDeleteOnly(false);
        await fetchProductDetails();
      } else {
        setLoadingState(false);
        notify("Unable to Save", "error");
      }
    }
  };

  // TO DO Port Changes 2
  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };

  const setZustandInitialState = (initialState?: any) => {
    const defaultState = {
      associatedShipmentNo: "",
      tcProductNo: "",
      tcProductCategoryCode: "",
      tcProductCategoryUserSpecificTerm: "",
      tcProductDetailCode: "",
      tcProductDetailUserSpecificTerm: "",
      tcProductProductionDate: "",
      tcNetShippingWeight: "",
      tcProductSupplementaryWeight: "",
      tcProductOrderNo: [""],
      tcProductShipmentNo: [""],
      tcProductArticleNo: "",
      tcProductNumberOfUnits: "",
      tcProductUnitsMetric: "",
      tcProductInfoAssociatedTc: "",
      // tcProductCertifiedWeight: "",
      // tcProductStandardLabelGrade: [],
      tcIsLastProcessorTECertitfied: "Y",
      tcProductLastProcessorTeId: "",
      tcProductLastProcessorName: "",
      tcProductLastProcessorCountry: "",
      tcProductLastProcessorLicenseNo: "",
      tcProductInfoFiberLength: "",
      tcProductInfoYarnCount: "",
      tcProductInfoFabricWeightAndConstruct: "",
      tcProductInfoFabricWeightOfFinishedProduct: "",
      tcProductInfoTrimsExcluded: "",
      tcProductAdditives: [],
      tcProductAdditivesWeight: null,
      tcProductInfoAdditional: "",
      "raw-material-info": [
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: "",
        },
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: "",
        },
      ],
    };
    //set zustand state inital values
    Object.entries(initialState ?? defaultState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  useEffect(() => {
    // setZustandInitialState(null);
    // const certifiedProductsDatas = getCurrentTableData()
    // Utills.cl(`certifiedProductsDatas ${certifiedProductsDatas}`)
    // if (certifiedProductsDatas != null) {
    //   setData(certifiedProductsDatas)
    // }
    if (TE_ID) {
      setTableData(null);
      setDashboardLoading(true);
      fetchProductDetails();
    } else {
      setTableData([]);
      setDashboardLoading(false);
      updateTableData([]);
    }
    // TO DO Port Changes 5
    resetFormValueByPage();
    shipmentFormData();
    setZustandInitialState(null);
    setRestrictPopUpSave(false);
  }, [TE_ID, pagination?.pageIndex]);

  const handleNext = async () => {
    if (formRefs[activeStep]?.current) {
      let stepSuccess = true;
      // Weight validate API is only needed for "add product WITHOUT component" flow.
      // For "Save & Add Component" (addWithComponent === true) we skip this call.
      if (activeStep === 0 && !addWithComponent) {
        const formValues = formRefs[activeStep]?.current?.values ?? {};
        if (!isUpToFiveDecimals(formValues.tcNetShippingWeight)) {
          notify(
            "Net shipping weight must be a valid number with up to 5 decimal places.",
            "error"
          );
          stepSuccess = false;
        }

        if (
          formValues.tcProductSupplementaryWeight !== null &&
          formValues.tcProductSupplementaryWeight !== undefined &&
          formValues.tcProductSupplementaryWeight !== "" &&
          !isUpToFiveDecimals(formValues.tcProductSupplementaryWeight)
        ) {
          notify(
            "Supplementary weight must be a valid number with up to 5 decimal places.",
            "error"
          );
          stepSuccess = false;
        }

        if (
          formValues.tcProductAdditivesWeight !== null &&
          formValues.tcProductAdditivesWeight !== undefined &&
          formValues.tcProductAdditivesWeight !== "" &&
          !isUpToFiveDecimals(formValues.tcProductAdditivesWeight)
        ) {
          notify(
            "Product additives weight must be a valid number with up to 5 decimal places.",
            "error"
          );
          stepSuccess = false;
        }

        if (!stepSuccess) {
          return;
        }
        const shipmentNoRaw = formValues.tcProductShipmentNo;
        const shipmentNo = Array.isArray(shipmentNoRaw)
          ? shipmentNoRaw[0] ?? ""
          : shipmentNoRaw ?? "";

        const shipmentInfo = getShipmentIdsByNumbers(shipmentData, shipmentNo);
        const resolvedShipmentId = Array.isArray(shipmentInfo?.shipmentId)
          ? shipmentInfo.shipmentId[0]
          : shipmentInfo?.shipmentId;

        if (!resolvedShipmentId) {
          notify("Please select a valid Shipment No.", "error");
          stepSuccess = false;
        } else {
          const existingProduct = tableData?.find(
            (product) => product?.tcProductNo === formValues.tcProductNo
          );

          const baseUrl = `${
            TCAppConfig.PRODUCT_WEIGHT_VALIDATE
          }?tcId=${TE_ID}&shipmentId=${resolvedShipmentId}&weight=${
            formValues.tcNetShippingWeight
          }`;

          const productIdForValidation =
            isEdit && (existingProduct?.productId || productId)
              ? existingProduct?.productId || productId
              : undefined;

          const url = productIdForValidation
            ? `${baseUrl}&productId=${productIdForValidation}`
            : baseUrl;

          try {
            const result: any = await executeShipment(url);
            if (result.status === 409) {
              stepSuccess = false;
            }
          } catch (err) {
            console.error(err);
          }
        }
      }
      if (stepSuccess) {
        const formRef = formRefs[activeStep]?.current;
        if (!formRef) return;
        const errors = await formRef.validateForm();
        await formRef.submitForm();
        if (Object.keys(errors).length === 0) {
          if (activeStep === 0) {
            if (addWithComponent) {
              // Use form values (source of truth at click) - stepData may not be updated yet on first click
              const formValues = formRef?.values ?? {};
              const shipmentNoRaw = formValues.tcProductShipmentNo;
              const shipmentNo =
                Array.isArray(shipmentNoRaw)
                  ? shipmentNoRaw[0] ?? ""
                  : shipmentNoRaw ?? "";
              const shipmentInfo = getShipmentIdsByNumbers(shipmentData, shipmentNo);
              const resolvedShipmentId = Array.isArray(shipmentInfo?.shipmentId)
                ? shipmentInfo.shipmentId[0]
                : shipmentInfo?.shipmentId;
              if (!resolvedShipmentId || !shipmentInfo?.tcShipmentDocNo?.length) {
                notify("Please select a valid Shipment No.", "error");
                return;
              }

              // For EDIT product with component: decide whether we need to POST or just open component workspace.
              if (isEdit && productId) {
                const existingProductNo = originalProductNoRef.current ?? "";
                const existingShipmentNo = originalShipmentNoRef.current ?? "";
                const currentProductNo = formValues.tcProductNo ?? "";
                const currentShipmentNoRaw = formValues.tcProductShipmentNo;
                const currentShipmentNo = Array.isArray(currentShipmentNoRaw)
                  ? currentShipmentNoRaw[0] ?? ""
                  : currentShipmentNoRaw ?? "";
                const isProductNoChanged =
                  existingProductNo !== currentProductNo;
                const isShipmentChanged =
                  existingShipmentNo !== currentShipmentNo;

                // If user changed product/shipment key, ask for confirmation and then POST (rename behaviour).
                if (isProductNoChanged || isShipmentChanged) {
                  setPendingComponentFormValues({
                    formValues,
                    shipmentNo,
                    shipmentInfo,
                    resolvedShipmentId,
                  });
                  setEditWithComponentConfirmOpen(true);
                  return;
                }

                // If neither productNo nor shipmentNo changed, skip POST and directly open component workspace.
                setProductId(productId);
                setShipmentId(resolvedShipmentId);
                setShipmentNo(shipmentNo);
                setComponentModalOpen(true);
                return;
                }

              setSaveAndAddComponentsLoading(true);
              try {
                const payload = mapBasicProductPayload(
                  { ...stepData.productInfo, ...formValues },
                  TE_ID ?? "",
                  shipmentInfo.tcShipmentDocNo
                );
                const url = `${TCAppConfig.CERTIFIED_PRODUCT_DETAILS_ENDPOINT}?tcId=${TE_ID}&shipmentId=${resolvedShipmentId}&oldShipmentId=${resolvedShipmentId}&oldShipmentNo=${encodeURIComponent(
                  encodeURIComponent(shipmentNo)
                )}&sameProdNewShipCreate=No&oldProductNo=`;
                const result: any = await executePost(url, {
                  ...payload,
                  tcProductInformation: [
                    {
                      ...payload.tcProductInformation[0],
                      tcAssociatedProductShipmentNo: Array.isArray(
                        payload.tcProductInformation[0]?.tcAssociatedProductShipmentNo
                      )
                        ? payload.tcProductInformation[0].tcAssociatedProductShipmentNo
                        : [payload.tcProductInformation[0]?.tcAssociatedProductShipmentNo],
                    },
                  ],
                });
                if (result?.status === 200) {
                  let rawData = result?.data;
                  let message: string = "";
                  let newProductId: string | null = null;

                  // If API returned a JSON string, try to parse it
                  if (typeof rawData === "string") {
                    const trimmed = rawData.trim();
                    if (
                      (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
                      (trimmed.startsWith("[") && trimmed.endsWith("]"))
                    ) {
                      try {
                        rawData = JSON.parse(trimmed);
                      } catch {
                        // fall through and treat as plain string
                      }
                    }
                  }

                  if (rawData && typeof rawData === "object") {
                    message =
                      (rawData as any).message ??
                      (result as any)?.message ??
                      "";
                    newProductId = (rawData as any).productId ?? null;
                  } else {
                    message =
                      typeof rawData === "string"
                        ? rawData
                        : (result as any)?.message ?? "";
                  }

                  // Fallback: extract productId from plain message text, e.g. "..., productId:01ABC..."
                  if (!newProductId && message) {
                    const productIdMatch = message.match(/productId:([^,"\s]+)/);
                    if (productIdMatch) {
                      newProductId = productIdMatch[1];
                    }
                  }

                  // Show any server message to the user
                  if (message) {
                    const trimmedMsg = message.trim();
                    if (trimmedMsg.startsWith("Data inserted/updated successfully")) {
                      notify("Data inserted/updated successfully", "success");
                    } else {
                      notify(trimmedMsg, "error");
                    }
                  }

                  if (newProductId) {
                    const isExistingCombination =
                      message &&
                      message
                        .toLowerCase()
                        .includes(
                          "product number and shipment number combination already exists"
                        );

                    // When the product/shipment combination already exists (add or edit),
                    // do not navigate to the component workspace. User must correct Product No.
                    if (!isExistingCombination) {
                      setProductId(newProductId);
                      setShipmentId(resolvedShipmentId);
                      setShipmentNo(shipmentNo);
                      setStepData((prev) => ({
                        ...prev,
                        productInfo: { ...prev.productInfo, ...formValues },
                      }));
                      setComponentModalOpen(true);
                    }
                  } else {
                    notify("Could not retrieve productId from response", "error");
                  }
                } else {
                  notify(result?.data?.message ?? "Unable to save product", "error");
                }
              } catch (err) {
                console.error("Save & Add Components failed:", err);
                notify("Failed to save product", "error");
              } finally {
                setSaveAndAddComponentsLoading(false);
              }
            } else {
              setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Next step (without component flow)
            }
          } else {
            setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
          }
        } else {
          const getFirstValidationMessage = (errObj: any): string => {
            if (!errObj) return "";
            if (typeof errObj === "string") return errObj;
            if (Array.isArray(errObj)) {
              for (const item of errObj) {
                const msg = getFirstValidationMessage(item);
                if (msg) return msg;
              }
              return "";
            }
            if (typeof errObj === "object") {
              for (const key of Object.keys(errObj)) {
                const msg = getFirstValidationMessage(errObj[key]);
                if (msg) return msg;
              }
            }
            return "";
          };
          const firstErrorMsg = getFirstValidationMessage(errors);
          notify(firstErrorMsg || "Please Enter the Required Values", "error");
        }
      }
    } else {
      if (addWithComponent && activeStep === 1) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
        return;
      }
      if (activeStep === 1 && !addWithComponent) {
        const totalPercentage = stepData.rawMaterialInfo.reduce((sum, item) => {
          const percent = parseFloat(
            item.tcProductRawMaterialPercentage || "0"
          );
          return sum + (isNaN(percent) ? 0 : percent);
        }, 0);
        const roundedTotal = parseFloat(totalPercentage.toFixed(5));
        if (stepData.rawMaterialInfo && stepData.rawMaterialInfo.length <= 0) {
          notify("Raw Material Info is Required", "error");
          return;
        }
        if (roundedTotal !== 100) {
          notify(
            "Total Product Raw Material Percentage should be 100",
            "error"
          );
          return;
        }
        if (stepData.rawMaterialInfo.length > 0) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify("Please Enter the Required Values", "error");
        }
      }
      if (activeStep === 4) {
        if (stepData.standardInfo.length > 0 || getTCStandardGOTS) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify("Please Enter the Required Values", "error");
        }
      }
    }
  };

  const mapToPayload = (data: any, tcId: any, tcNetShippingWeight: any) => {
    return {
      tcId: tcId, // Main ID
      tcNetShippingWeight: tcNetShippingWeight, // Total shipping weight
      tcProductInformation: data.map((item: any, index: number) => ({
        tcProductOrder: (index + 1).toString(), // Populate if necessary
        tcProductNo: item.tcProductNo,
        tcProductOrderNo: item.tcProductOrderNo,
        tcProductArticleNo: item.tcProductArticleNo,
        tcProductNumberOfUnits: item.tcProductNumberOfUnits || 0,
        tcProductUnitsMetric: item.tcProductUnitsMetric,
        tcNetShippingWeight: item.tcNetShippingWeight,
        tcProductSupplementaryWeight:
          parseInt(item.tcProductSupplementaryWeight) || 0,
        tcProductProductionDate: item.tcProductProductionDate,
        tcProductCategoryCode: item.tcProductCategoryCode,
        tcProductCategoryCodeDescription:
          useTransactionCertificateStore
            .getState()
            .getProductCategoriesStore.find(
              (option: any) => option.value === item.tcProductCategoryCode
            )?.label || "",
        tcProductCategoryUserSpecificTerm:
          item.tcProductCategoryUserSpecificTerm,
        tcProductDetailCode: item.tcProductDetailCode,
        tcProductDetailUserSpecificTerm: item.tcProductDetailUserSpecificTerm,
        tcProductInfoTrimsExcluded: item.tcProductInfoTrimsExcluded,
        tcProductInfoAssociatedTc: item.tcProductInfoAssociatedTc,
        tcProductInfoFiberLength: item.tcProductInfoFiberLength,
        tcProductInfoYarnCount: item.tcProductInfoYarnCount,
        tcProductInfoFabricWeightAndConstruct:
          item.tcProductInfoFabricWeightAndConstruct,
        tcProductInfoFabricWeightOfFinishedProduct:
          item.tcProductInfoFabricWeightOfFinishedProduct,
        ocsProcessor: item.tcIsLastProcessorTECertitfied || "Y",
        tcProductLastProcessorName: item.tcProductLastProcessorName || "",
        tcProductLastProcessorTeId: item.tcProductLastProcessorTeId || "",
        tcProductLastProcessorLicenseNo:
          item.tcProductLastProcessorLicenseNo || "",
        tcProductLastProcessorCountry: item.tcProductLastProcessorCountry,
        tcProductLastProcessorCountryDescription:
          item.tcProductLastProcessorCountry
            ? useTransactionCertificateStore
                .getState()
                ?.getCountryCodes?.find(
                  (option: any) =>
                    option.value === item.tcProductLastProcessorCountry
                )?.label || ""
            : "",
        tcProductInfoAdditional: item.tcProductInfoAdditional,
        tcProductAdditives: item?.tcProductAdditives || [],
        tcProductAdditivesWeight: item?.tcProductAdditivesWeight,
        tcProductShipmentNo: item.tcProductShipmentNo,
        tcProductStandardInformation: (item["standardInfo"] || []).map(
          (rawMaterial: any, index: any) => ({
            tcProductStandardLabelOrder: (index + 1).toString(),
            tcProductStandardLabelGrade:
              rawMaterial.tcProductStandardLabelGrade,
            tcProductCertifiedWeight: rawMaterial.tcProductCertifiedWeight,
          })
        ),
        tcProductRawMaterialInformation: (item["raw-material-info"] || []).map(
          (rawMaterial: any) => ({
            tcProductRawMaterialOrder:
              rawMaterial.tcProductRawMaterialOrder.toString(),
            tcProductRawMaterialCode: rawMaterial.tcProductRawMaterialCode,
            tcProductRawMaterialPercentage:
              parseFloat(parseFloat(rawMaterial.tcProductRawMaterialPercentage).toFixed(5)),
            tcProductRawMaterialUserSpecificTerm: rawMaterial.tcProductRawMaterialUserSpecificTerm,
          })
        ),
      })),
    };
  };


  const onNext = () => {
    navigate(`/tc/${formtype}/tc-standard-weight/${TE_ID}`);
  };
  const handleConfirmEditWithComponent = async () => {
    if (!pendingComponentFormValues || !TE_ID) {
      setEditWithComponentConfirmOpen(false);
      return;
    }

    const { formValues, shipmentNo, shipmentInfo, resolvedShipmentId } =
      pendingComponentFormValues;

    setEditWithComponentConfirmOpen(false);
    setSaveAndAddComponentsLoading(true);
    try {
      const oldProductNo = originalProductNoRef.current ?? "";

      const payload = mapBasicProductPayload(
        { ...stepData.productInfo, ...formValues },
        TE_ID ?? "",
        shipmentInfo.tcShipmentDocNo
      );
      const url = `${TCAppConfig.CERTIFIED_PRODUCT_DETAILS_ENDPOINT}?tcId=${TE_ID}&shipmentId=${resolvedShipmentId}&oldShipmentId=${resolvedShipmentId}&oldShipmentNo=${encodeURIComponent(
        encodeURIComponent(shipmentNo)
      )}&sameProdNewShipCreate=No&oldProductNo=${encodeURIComponent(
        encodeURIComponent(oldProductNo || "")
      )}`;
      const result: any = await executePost(url, {
        ...payload,
        tcProductInformation: [
          {
            ...payload.tcProductInformation[0],
            tcAssociatedProductShipmentNo: Array.isArray(
              payload.tcProductInformation[0]?.tcAssociatedProductShipmentNo
            )
              ? payload.tcProductInformation[0].tcAssociatedProductShipmentNo
              : [payload.tcProductInformation[0]?.tcAssociatedProductShipmentNo],
          },
        ],
      });
      if (result?.status === 200) {
        let rawData = result?.data;
        let message: string = "";
        let newProductId: string | null = null;

        if (typeof rawData === "string") {
          const trimmed = rawData.trim();
          if (
            (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"))
          ) {
            try {
              rawData = JSON.parse(trimmed);
            } catch {
              // fall through
            }
          }
        }

        if (rawData && typeof rawData === "object") {
          message = (rawData as any).message ?? (result as any)?.message ?? "";
          newProductId = (rawData as any).productId ?? null;
        } else {
          message =
            typeof rawData === "string"
              ? rawData
              : (result as any)?.message ?? "";
        }

        if (!newProductId && message) {
          const productIdMatch = message.match(/productId:([^,"\s]+)/);
          if (productIdMatch) {
            newProductId = productIdMatch[1];
          }
        }

        if (message) {
          const trimmedMsg = message.trim();
          if (trimmedMsg.startsWith("Data inserted/updated successfully")) {
            notify("Data inserted/updated successfully", "success");
          } else {
            notify(trimmedMsg, "error");
          }
        }

        if (newProductId) {
          const isExistingCombination =
            message &&
            message
              .toLowerCase()
              .includes(
                "product number and shipment number combination already exists"
              );

          // When the product/shipment combination already exists during edit,
          // do not navigate to the component workspace. User must correct Product No.
          if (!isExistingCombination) {
            setProductId(newProductId);
            setShipmentId(resolvedShipmentId);
            setShipmentNo(shipmentNo);
            // Update stepData so form fields reflect the saved (new) values
            setStepData((prev) => ({
              ...prev,
              productInfo: { ...prev.productInfo, ...formValues },
            }));
            originalProductNoRef.current = formValues.tcProductNo ?? originalProductNoRef.current;
            setComponentModalOpen(true);
          }
        } else {
          notify("Could not retrieve productId from response", "error");
        }
      } else {
        notify(result?.data?.message ?? "Unable to save product", "error");
      }
    } catch (err) {
      console.error("Save & Add Components failed:", err);
      notify("Failed to save product", "error");
    } finally {
      setSaveAndAddComponentsLoading(false);
      setPendingComponentFormValues(null);
    }
  };
  const handleSave = async (payload: any, oldProductNo: string = "") => {
    // const certifiedPrdtData: any = getCurrentTableData()
    // const totalNetShippingWeight = certifiedPrdtData.reduce((sum: any, item: any) => {
    //   return sum + parseFloat(item.tcNetShippingWeight || 0);
    // }, 0);
    // const payload = mapToPayload(certifiedPrdtData, TE_ID, totalNetShippingWeight);
    // TODO Commeneted for demo
    if (!TE_ID) {
      return;
    }
    const shipmentInfo = getShipmentIdsByNumbers(
      shipmentData,
      Array.isArray(stepData?.productInfo.tcProductShipmentNo)
        ? stepData?.productInfo.tcProductShipmentNo[0]
        : stepData?.productInfo.tcProductShipmentNo || ""
    );

    const oldShipmentIdArray = shipmentId ? [shipmentId] : [];
    const oldShipmentIdParam = JSON.stringify(oldShipmentIdArray);
    const oldShipmentNo = shipmentNo
      ? shipmentNo
      : payload?.tcProductInformation[0].tcAssociatedProductShipmentNo;
    const existingProductAndShipment: any = tableData?.find(
      (item) => item.tcProductNo === payload.tcProductInformation[0].tcProductNo
    );
    const sameProdNewShipCreate = !isEdit ? existingProductAndShipment : null;
    const finalUrl = `${
      TCAppConfig.CERTIFIED_PRODUCT_DETAILS_ENDPOINT
    }?tcId=${TE_ID}&shipmentId=${shipmentInfo.shipmentId}&oldShipmentId=${
      shipmentId ? shipmentId : shipmentInfo?.shipmentId
    }&oldShipmentNo=${encodeURIComponent(
      encodeURIComponent(oldShipmentNo)
    )}&sameProdNewShipCreate=${
      sameProdNewShipCreate !== null && sameProdNewShipCreate !== undefined
        ? "Yes"
        : "No"
    }&oldProductNo=${encodeURIComponent(
      encodeURIComponent(oldProductNo || "")
    )}`;

    try {
      
      const firstPayloadRm =
        payload?.tcProductInformation?.[0]?.tcProductRawMaterialInformation?.[0];
      const firstStepRm = stepData?.rawMaterialInfo?.[0];
      if (firstPayloadRm && firstStepRm?.tcProductRawMaterialUserSpecificTerm) {
        firstPayloadRm.tcProductRawMaterialUserSpecificTerm =
          firstStepRm.tcProductRawMaterialUserSpecificTerm;
      }

      const result: any = await executePost(finalUrl, {
        ...payload,
        tcProductInformation: [
          {
            ...payload?.tcProductInformation[0],
            tcAssociatedProductShipmentNo: Array.isArray(
              payload?.tcProductInformation[0]?.tcAssociatedProductShipmentNo
            )
              ? payload?.tcProductInformation[0]?.tcAssociatedProductShipmentNo
              : [
                  payload?.tcProductInformation[0]
                    ?.tcAssociatedProductShipmentNo,
                ],
          },
        ],
        ...(sameProdNewShipCreate !== null
          ? { productId: sameProdNewShipCreate?.productId }
          : isEdit && existingProductAndShipment?.productId === productId
          ? { productId: productId }
          : {}),
      });

      if (result.status == 200) {
        notify("Data Saved Successfully", "success");
        if (pendingSave) {
          setPendingSave(null);
        }
        fetchProductDetails();
        setStepData({
          productInfo: initTcProduct,
          standardInfo: initStandardInfo,
          lastProcessorInfo: initLastProcessorInfo,
          additionalInfo: initAdditonalInfo,
          rawMaterialInfo: initRawMaterialInfo,
        });

        toggleDrawer();
        await onNextTab();
      } else if (result.status === 409) {
        setLoadingState(false);
      } else {
        setLoadingState(false);
        notify("Unable to Save", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };
  const handleAdminNext = () => {
    // For admin viewing a product WITH components at step 0: open the component workspace (view-only).
    if (addWithComponent && activeStep === 0 && productId) {
      setComponentModalOpen(true);
      return;
    }
    // On the last step, close the modal (no save for admin).
    if (activeStep === steps.length - 1) {
      toggleDrawer();
      return;
    }
    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };
  const handleProductModalClose = () => {
    // In add/edit with component flow, prompt before closing when user is in
    // intermediate/final form steps without saving from last step.
    if (addWithComponent && !isEdit && activeStep >= 1) {
      setDiscardChangesConfirmOpen(true);
      return;
    }
    toggleDrawer();
  };
  const handleCancelDiscardChanges = () => {
    setDiscardChangesConfirmOpen(false);
  };
  const handleConfirmDiscardChanges = async () => {
    setDiscardChangesConfirmOpen(false);
    if (!TE_ID || !productId) {
      toggleDrawer();
      return;
    }
    try {
      const res = await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.product,
        tcId: TE_ID,
        productId: productId,
        shipmentId: shipmentId,
        shipmentNo: encodeURIComponent(
          encodeURIComponent(shipmentNo ?? "")
        ),
        productNo: encodeURIComponent(
          encodeURIComponent(stepData?.productInfo?.tcProductNo ?? "")
        ),
      });
      if (res?.status === 200) {
        setProductId(null);
        createdProductSnapshotRef.current = null;
        setProductDerivedComponents([]);
        await fetchProductDetails();
      }
    } catch (error) {
      console.error("Error while discarding product changes:", error);
    } finally {
      toggleDrawer();
    }
  };
  const handleFinish = async () => {
    if (isAdmin) {
      navigate(`/tc/${formtype}/component-details/${TE_ID}`);
      return;
    }
    
    if (activeStep === 1) {
      const totalPercentage = stepData.rawMaterialInfo.reduce((sum, item) => {
        const percent = parseFloat(item.tcProductRawMaterialPercentage || "0");
        return sum + (isNaN(percent) ? 0 : percent);
      }, 0);
      const roundedTotal = parseFloat(totalPercentage.toFixed(5));
      if (stepData.rawMaterialInfo && stepData.rawMaterialInfo.length <= 0) {
        notify("Raw Material Info is Required", "error");
        return;
      }
      if (roundedTotal !== 100) {
        notify("Total Product Raw Material Percentage should be 100", "error");
        return;
      }
    }
    if (activeStep === 4) {
      if (stepData.standardInfo.length <= 0) {
        notify("Standard Info is Required", "error");
        return;
      } else if (stepData.standardInfo.length > 0) {
        const totalStandardCertifiedWeight = stepData.standardInfo.reduce(
          (sum, item) => {
            const weight = parseFloat(item.tcProductCertifiedWeight || "0");
            return sum + (isNaN(weight) ? 0 : weight);
          },
          0
        );

        if (
          Math.abs(totalCertifiedWeight - Number(totalStandardCertifiedWeight.toFixed(5))) > 2
        ) {
          notify(
            "Total Certified Weight is not equal to the Standard Certified Raw Material Weight",
            "error"
          );
          return;
        }
      }
    }

    const shipmentInfo = getShipmentIdsByNumbers(
      shipmentData,
      Array.isArray(stepData?.productInfo.tcProductShipmentNo)
        ? stepData?.productInfo.tcProductShipmentNo[0]
        : stepData?.productInfo.tcProductShipmentNo || ""
    );

    if (TE_ID) {
      // For products WITHOUT components, inject the certified and non-certified
      let finalStepData = stepData;
      if (!addWithComponent) {
        const netShippingWeight = Number(stepData.productInfo.tcNetShippingWeight) || 0;
        const supplementaryWeight = Number(stepData.productInfo.tcProductSupplementaryWeight) || 0;
        const additivesWeight = Number(stepData.productInfo.tcProductAdditivesWeight) || 0;
        const certifiedTotal = totalCertifiedWeight;
        const nonCertifiedTotal = Math.max(
          0,
          netShippingWeight - supplementaryWeight - additivesWeight - certifiedTotal
        );
        finalStepData = {
          ...stepData,
          productInfo: {
            ...stepData.productInfo,
            tcProductCertifiedWeightTotal: certifiedTotal,
            tcProductNonCertifiedWeightTotal: nonCertifiedTotal,
          },
        };
      } else {
        const overlayInfo = stepData.productInfo as any;
        const totalSupplementaryWeight = Number(overlayInfo.totalSupplementaryWeight);
        if (totalSupplementaryWeight) {
          finalStepData = {
            ...stepData,
            productInfo: {
              ...stepData.productInfo,
              tcProductSupplementaryWeight: totalSupplementaryWeight.toString(),
            },
          };
        }
      }

      const payload = mapProductData(
        finalStepData,
        TE_ID,
        shipmentInfo?.tcShipmentDocNo,
        productId
      );

      if (productId && payload.tcProductInformation[0].tcProductNo) {
        //alert("test1")
        // Find the shipment in the table data that matches the provided productId
        const existingProduct: any = tableData?.find(
          (item) => item.productId === productId
        );
        const isChanged =
          existingProduct &&
          existingProduct.tcProductNo !==
            payload.tcProductInformation[0].tcProductNo;
        // If the product exists and its number has changed, delete the old one first
        const isShipmentChanged = existingProduct != null; // && !_.isEqual(existingProduct.tcProductShipmentNo, payload.tcProductInformation[0].tcProductShipmentNo);
        console.log(
          isShipmentChanged,
          existingProduct?.tcProductShipmentNo,
          payload.tcProductInformation[0].tcProductShipmentNo,
          "32"
        );
        setIsValueChanged(isShipmentChanged || false);
        if (isChanged) {
          const row = {
            original: {
              tcProductNo: existingProduct?.tcProductNo,
              productId: productId,
            },
          };

          //alert("test2")
          // Delete the existing product first, then save the new one
          await onEditDelete(row);
          // The actual save will happen in the handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If it's a new product or no changes to product number, save directly
        handleSave(payload);
      } else if (!productId) {
        // This is a new product, not an edit
        // check whether product and shipment combination already exists
        handleSave(payload);
      }
    }

    // if (editingIndex === -1) {
    //   setDeleteSave(false)
    // const userFilledValues = getCurrentFormValues()

    // if (editingIndex >= 0) {
    //   updateTableRowbyIndex(editingIndex, userFilledValues)
    //   const certifiedProductsDatas = getCurrentTableData()
    //   setData(certifiedProductsDatas);
    //   if (getEditExistingShipment.index === editingIndex) {
    //     if (certifiedProductsDatas[editingIndex]?.tcProductNo != getEditExistingShipment.value) {
    //       setDeleteSave(true)
    //     }
    //     else {
    //       setEditExistingShipment({
    //         index: -1, value: ''
    //       })
    //       setDeleteSave(false)
    //     }
    //   }
    //   setNextEnabled(false)
    // } else {
    //   updateTableData([getCurrentFormValues()]);
    //   const certifiedProductsDatas = getCurrentTableData()
    //   setData(certifiedProductsDatas);
    //   setNextEnabled(false)
    // }
    // if (getDeleteSave()) {
    //   setPendingSave(userFilledValues)
    //   setDialogOpen(true)
    //   setPopUpBtnName("Save")
    //   setPopUpTitle("Confirm Edit ?")
    //   setPopUpMessage(`Editing Product No field will remove all the Associated Records, are you sure want to Save it`)
    //   // setDeleteSave(false)
    //   return null
    // }
    // // Reset editing index
    // setEditingIndex(-1);

    // Reset stepData to its initial state
    // Close the drawer
  };

  const actions: ActionButtonConfig[] = [
    ...(activeStep !== 0
      ? [
          {
            label: "Back",
            onClick: handleBack,
            variant: "contained" as "contained",
            color: "default" as "default",
            disabled: activeStep === 0,
          },
        ]
      : []),
    {
      label:
        activeStep === 0
          ? isAdmin
            ? "Next"
            : addWithComponent
            ? "Save & Add Components"
            : "Next"
          : activeStep === steps.length - 1
          ? isAdmin
            ? "Next"
            : "Save"
          : "Next",
      onClick: isAdmin
        ? handleAdminNext
        : activeStep === steps.length - 1
        ? handleFinish
        : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled:
        !isAdmin && (activeStep === 3 || activeStep === 1 || activeStep === 4)
          ? isRestrictPopUpSave
          : !isAdmin && activeStep === 4
          ? disableOnEdit
          : false,
      isLoading: !isAdmin && (nextLoader || saveAndAddComponentsLoading) && activeStep === 0,
    },
  ];

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "tcAssociatedProductShipmentNo",
      header: "Shipment Number",
      minSize: 60,
      Cell: ({ cell }: { cell: any }) => {
        const selectedValues = cell.getValue() || [];
        return (
          <div>
            {Array.isArray(selectedValues) && selectedValues.length > 0
              ? selectedValues.join(", ")
              : ""}
          </div>
        );
      },
      maxSize: 180,
    },
    {
      accessorKey: "tcProductNo",
      header: "Product Number",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcNetShippingWeight",
      header: "Net Shipping Weight (kg)",
      minSize: 60,
      maxSize: 150,
      Cell: ({ cell }) => formatDynamicDecimals(cell.getValue()),
    },
    {
      accessorKey: "tcProductSupplementaryWeight",
      header: "Supplementary Weight (kg)",
      minSize: 60,
      maxSize: 150,
      Cell: ({ cell }) => formatDynamicDecimals(cell.getValue()),
    },
    {
      accessorKey: "tcCertifiedWeight",
      header: "Product Certified Weight (kg)",
      minSize: 60,
      maxSize: 200,
      Cell: ({ cell }) => formatDynamicDecimals(cell.getValue()),
    },
    {
      accessorKey: "tcNonCertifiedWeight",
      header: "Product Non-Certified Weight (kg)",
      minSize: 60,
      maxSize: 200,
      Cell: ({ cell }) => formatDynamicDecimals(cell.getValue()),
    },
    // {
    //   accessorKey: "tcProductOrderNo",
    //   header: "Order No.",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    // {
    //   accessorKey: "tcProductArticleNo",
    //   header: "Article No.",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    // {
    //   accessorKey: "tcProductNumberOfUnits",
    //   header: "Number of Units",
    //   minSize: 60,
    //   maxSize: 150,
    //   Cell: Utills.usNumberFormat,
    // },
    // {
    //   accessorKey: "tcProductUnitsMetric",
    //   header: "Units Metric",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    // {
    //   accessorKey: "tcProductProductionDate",
    //   header: "Production Date",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    // {
    //   accessorKey: "tcProductCategoryCodeDescription",
    //   header: "Product Category",
    //   minSize: 150,
    //   maxSize: 200,
    // },
    // {
    //   accessorKey: "tcProductInfoAssociatedTc",
    //   header: "Associated TC",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    // { accessorKey: 'tcProductCertifiedWeight', header: 'Certified Weight', minSize: 60, maxSize: 150, Cell: Utills.usNumberFormat },
    // { accessorKey: 'tcProductStandardLabelGrade', header: 'Standard Label Grade', minSize: 60, maxSize: 150 },
    // { accessorKey: 'tcProductStandardLabelOrder', header: 'Label Order', minSize: 60, maxSize: 150 },
  ];
  const renderDetailPanel = ({ row }: { row: any }) => {
    const lastProcessorInfo = {
      tcIsLastProcessorTECertitfied: row.original.tcIsLastProcessorTECertitfied,
      tcProductLastProcessorCountry: row.original.tcProductLastProcessorCountry,
      tcProductLastProcessorLicenseNo:
        row.original.tcProductLastProcessorLicenseNo,
      tcProductLastProcessorName: row.original.tcProductLastProcessorName,
      tcProductLastProcessorTeId: row.original.tcProductLastProcessorTeId,
    };
    const additionalInfo = {
      tcProductInfoFiberLength: row.original.tcProductInfoFiberLength,
      tcProductInfoYarnCount: row.original.tcProductInfoYarnCount,
      tcProductInfoFabricWeightAndConstruct:
        row.original.tcProductInfoFabricWeightAndConstruct,
      tcProductInfoFabricWeightOfFinishedProduct:
        row.original.tcProductInfoFabricWeightOfFinishedProduct,
      tcProductInfoTrimsExcluded: row.original.tcProductInfoTrimsExcluded,
      tcProductAdditives: row?.original?.tcProductAdditives,
      tcProductAdditivesWeight: row?.original?.tcProductAdditivesWeight,
    };
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 5,
          gap: 4,
          width: "80%",
        }}
      >
        {/* First Table - Processor Information */}
        <Box sx={{ width: "100%", textAlign: "left", mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Processor Information
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcIsLastProcessorTECertitfied",
                header: "Last Processor TE-certified?",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorCountry",
                header: "Last Processor Country",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorTeId",
                header: "Last Processor TE-ID",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorName",
                header: "Last Processor Name",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorLicenseNo",
                header: "Last Processor License No.",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={[lastProcessorInfo]}
            enableTopToolbar={false}
            enableRowActions={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Second Table - Fabric and Material Details */}
        <Box sx={{ width: "100%", textAlign: "left", mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Fabric and Material Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcProductInfoFiberLength",
                header: "Fiber Length (mm)",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductInfoYarnCount",
                header: "Yarn Count",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductInfoFabricWeightAndConstruct",
                header: "Fabric Weight and Construct (kg)",
                minSize: 60,
                maxSize: 150,
                Cell: ({ cell }: { cell: any }) => formatDynamicDecimals(cell.getValue()),
              },
              {
                accessorKey: "tcProductInfoFabricWeightOfFinishedProduct",
                header: "Fabric Weight of Finished Product (kg)",
                minSize: 60,
                maxSize: 150,
                Cell: ({ cell }: { cell: any }) => formatDynamicDecimals(cell.getValue()),
              },
              {
                accessorKey: "tcProductInfoTrimsExcluded",
                header: "Trim Excluded",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={[additionalInfo]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Third Table - Raw Material Composition */}
        <Box sx={{ width: "100%", textAlign: "left" }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Standard Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcProductCertifiedWeight",
                header: "Certified Weight (kg)",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductStandardLabelGrade",
                header: "Standard Label Grade",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={row.original["standardInfo"]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Third Table - Raw Material Composition */}
        <Box sx={{ width: "100%", textAlign: "left" }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Raw Material Composition
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcProductRawMaterialCode",
                header: "Raw Material Code",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductRawMaterialPercentage",
                header: "Raw Material Percentage",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={row.original["raw-material-info"]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
      </Box>
    );
  };

  const mapToCertifiedProductDetails = (data: any) => {
    Utills.cl("edit", data);
    return {
      tcId: data.associatedShipmentNo,
      tcNetShippingWeight: data.tcNetShippingWeight,
      tcProductInformation: {
        tcProductNo: data.tcProductNo,
        tcProductCategoryCode: data.tcProductCategoryCode,
        tcProductProductionDate: data.tcProductProductionDate,
        tcNetShippingWeight: data.tcNetShippingWeight,
        tcProductSupplementaryWeight: data.tcProductSupplementaryWeight,
        tcProductOrderNo: data.tcProductOrderNo,
        tcProductArticleNo: data.tcProductArticleNo,
        tcProductNumberOfUnits: data.tcProductNumberOfUnits,
        tcProductUnitsMetric: data.tcProductUnitsMetric,
        tcProductInfoAssociatedTc: data.tcProductInfoAssociatedTc,
        tcProductShipmentNo: data.tcProductShipmentNo || [],
        tcProductOrder: data.tcProductCategoryUserSpecificTerm, // Assuming this is what tcProductOrder maps to
        tcProductCategoryUserSpecificTerm:
          data.tcProductCategoryUserSpecificTerm,
        tcProductDetailCode: data.tcProductDetailCode,
        tcProductDetailUserSpecificTerm: data.tcProductDetailUserSpecificTerm,
      },
      tcProductStandardInformation: (data["standardInfo"] || []).map(
        (rawMaterial: any) => ({
          tcProductStandardLabelOrder:
            rawMaterial?.tcProductStandardLabelOrder.toString(),
          tcProductStandardLabelGrade:
            rawMaterial?.tcProductStandardLabelGrade || "",
          tcProductCertifiedWeight: rawMaterial?.tcProductCertifiedWeight || "",
        })
      ),
      tcProductLastProcessorInfo: {
        tcProductLastProcessorName: data.tcProductLastProcessorName || "",
        tcProductLastProcessorTeId: data.tcProductLastProcessorTeId || "",
        tcProductLastProcessorLicenseNo:
          data.tcProductLastProcessorLicenseNo || "",
        tcProductLastProcessorCountry: data.tcProductLastProcessorCountry || "",
        tcIsLastProcessorTECertitfied: data.tcIsLastProcessorTECertitfied || "",
      },
      tcProductAdditionalInfo: {
        tcProductInfoFiberLength: data.tcProductInfoFiberLength || "",
        tcProductInfoYarnCount: data.tcProductInfoYarnCount || "",
        tcProductInfoFabricWeightAndConstruct:
          data.tcProductInfoFabricWeightAndConstruct || "",
        tcProductInfoFabricWeightOfFinishedProduct:
          data.tcProductInfoFabricWeightOfFinishedProduct || "",
        tcProductInfoTrimsExcluded: data.tcProductInfoTrimsExcluded || "",
        tcProductInfoAdditional: data.tcProductInfoAdditional || "",
        tcProductAdditives: data?.tcProductAdditives || [],
        tcProductAdditivesWeight: data?.tcProductAdditivesWeight,
      },
      tcProductRawMaterialInformation: (data["raw-material-info"] || []).map(
        (rawMaterial: any) => ({
          tcProductRawMaterialOrder:
            rawMaterial.tcProductRawMaterialOrder.toString(),
          tcProductRawMaterialCode: rawMaterial.tcProductRawMaterialCode,
          tcProductRawMaterialPercentage:
            rawMaterial.tcProductRawMaterialPercentage.toString(),
        })
      ),
    };
  };
  const onEdit = (row: any) => {
    setIsEdit(true);
    const value = row?.original as ProductShipmentResponse;
    setProductId(value.productId);
    setShipmentId(value.shipmentId);
    const associatedShipmentNo =
      value?.tcAssociatedProductShipmentNo &&
      value?.tcAssociatedProductShipmentNo?.length > 0
        ? value?.tcAssociatedProductShipmentNo[0]
        : null;
    setShipmentNo(associatedShipmentNo);
    originalProductNoRef.current = value.tcProductNo ?? "";
    originalShipmentNoRef.current = associatedShipmentNo ?? "";
    // Set from list row immediately so Edit modal shows correct flow (with/without component)
    const hasComponentsFromRow =
      value?.tcProductHasComponents === "true" ||
      value?.tcProductHasComponents === true;
    setAddWithComponent(hasComponentsFromRow);

    if (TE_ID) {
      fetchProductaddDetails(
        executeGet,
        TE_ID,
        value.productId,
        value.shipmentId
      )
        .then((data) => {
          const productList = data?.data?.tcProductInformation;
          const netShippingWeight = data?.data?.tcNetShippingWeight;

          if (productList && productList.length > 0) {
            const product = productList[0];
            // Use tcProductHasComponents from product-details API; fallback to row value if missing
            const hasComponentsFromProduct =
              product.tcProductHasComponents === "true" ||
              product.tcProductHasComponents === true;
            const useProductValue =
              product.tcProductHasComponents !== undefined &&
              product.tcProductHasComponents !== null;
            setAddWithComponent(useProductValue ? hasComponentsFromProduct : hasComponentsFromRow);

            const mappedStepData = mapProductDataToStepData(
              product,
              netShippingWeight
            );
            console.log(mappedStepData);

            setStepData(mappedStepData);
          }
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
    }
  };

  const onDelete = (row: any) => {
    const tcProductNo = row?.original?.tcProductNo;
    const productId = row?.original?.productId;
    setDeleteShpId(row?.original?.shipmentId);
    setDeleteShpNo(row?.original?.tcAssociatedProductShipmentNo[0]);
    setProductId(productId);
    setDialogOpen(true);
    setTcProductNo(tcProductNo);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting Shipment ${tcProductNo} will remove all the Associated Records, are you sure want to delete it`
    );
  };
  const onEditDelete = (row: any) => {
    const tcProductNo = row?.original?.tcProductNo;
    const productId = row?.original?.productId;
    setTcProductNo(tcProductNo);
    setProductId(productId);
    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing Product No. ${tcProductNo} will remove all the Associated Records, are you sure want to edit it`
    );
  };
  const onAdd = (withComponent: boolean) => {
    setAddWithComponent(withComponent);
    setIsEdit(false);
    toggleDrawer();
  };

  const showLoader = dashboardLoading || tableData === null;

  return (
    <>
      {showLoader ? (
        <LoaderComponent />
      ) : (
        <>
          <Box mb={3} width="100%">
            <Typography fontWeight={600}>
              Product Creation Workspace
            </Typography>
            {!hasSubmitTC && !isAdmin && (
              <Box
                display="flex"
                flexDirection="column"
                gap={1}
                mt={2}
                alignItems="flex-end"
              >
                <Box display="flex" gap={2}>
                  <InfoOutlinedIcon sx={{ fontSize: 20, color: "warning.dark" }} />
                  <Typography variant="body2" color="text.secondary">
                    Please remember components are only intended to be included as
                    a part of a finished product
                  </Typography>
                </Box>
                <Box display="flex" gap={1}>
                  <StyledButton
                    variant="contained"
                    sx={{ boxShadow: "none" }}
                    onClick={() => onAdd(false)}
                  >
                    Add Product Without Component
                  </StyledButton>
                  <StyledButton
                    variant="contained"
                    sx={{ boxShadow: "none" }}
                    onClick={() => onAdd(true)}
                  >
                    Add Product With Component
                  </StyledButton>
                </Box>
              </Box>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData ?? []}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTC}
              renderDetailPanel={({ row }) =>
                row.getIsExpanded() ? (
                  <RenderDetailPanel
                    row={row}
                    onEditComponentRequest={(ctx) => {
                      setComponentEditContext(ctx);
                      setComponentModalOpen(true);
                    }}
                  />
                ) : (
                  <>NO data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={isAdmin ? undefined : onDelete} />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={handleProductModalClose}
            title={
              isEdit
                ? addWithComponent
                  ? "Edit Product With Component"
                  : "Edit Product Without Component"
                : addWithComponent
                  ? "Add Product With Component"
                  : "Add Product Without Component"
            }
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>

          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              {/* {!isNextEnabled && <InnerButton onClick={handleSave}>Save & Next</InnerButton>} */}
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              {tableData?.length > 0 && (
                <InnerButton onClick={onNext}>Next</InnerButton>
              )}
            </Box>
          ) : (
            <>
              {hasSubmitTC && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  <NavLink to={`/tc/${formtype}/shipments/${TE_ID}`}>
                    <InnerButton sx={{ boxShadow: "none" }}>Back</InnerButton>
                  </NavLink>
                  <InnerButton onClick={onNext} sx={{ boxShadow: "none" }}>
                    Next
                  </InnerButton>
                </Box>
              )}
            </>
          )}

          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />

          <AlertPopup
            open={editWithComponentConfirmOpen}
            title="Confirm Save ?"
            message={
              (() => {
                const existingProduct: any = tableData?.find(
                  (item) => item.productId === productId
                );
                const currentProductNo = existingProduct?.tcProductNo ?? "";
                return `Editing Product No. ${currentProductNo} will remove all the Associated Components, are you sure want to edit it`;
              })()
            }
            onClose={() => {
              setEditWithComponentConfirmOpen(false);
              setPendingComponentFormValues(null);
            }}
            onConfirm={handleConfirmEditWithComponent}
            confirmText="Save"
            cancelText="Cancel"
          />
          <AlertPopup
            open={discardChangesConfirmOpen}
            title="Confirm Discard?"
            message="Are you sure, you want to discard the changes for this product?"
            onClose={handleCancelDiscardChanges}
            onConfirm={handleConfirmDiscardChanges}
            confirmText="Confirm"
            cancelText="Cancel"
          />

          <ComponentCreationModal
            open={componentModalOpen}
            onClose={() => {
              setComponentModalOpen(false);
              setComponentEditContext(null);
            }}
            shipmentNumber={
              componentEditContext?.shipmentNumber ??
              (Array.isArray(stepData?.productInfo.tcProductShipmentNo)
                ? stepData?.productInfo.tcProductShipmentNo[0]
                : stepData?.productInfo.tcProductShipmentNo || "")
            }
            productNumber={
              componentEditContext?.productNumber ?? stepData?.productInfo.tcProductNo ?? ""
            }
            tcId={TE_ID ?? ""}
            productId={componentEditContext?.productId ?? productId ?? ""}
            shipmentId={
              componentEditContext?.shipmentId ??
              shipmentId ??
              (() => {
                const sn =
                  Array.isArray(stepData?.productInfo.tcProductShipmentNo)
                    ? stepData?.productInfo.tcProductShipmentNo[0]
                    : stepData?.productInfo.tcProductShipmentNo || "";
                if (!sn || !shipmentData?.length) return "";
                const info = getShipmentIdsByNumbers(shipmentData, sn);
                const id = Array.isArray(info?.shipmentId) ? info.shipmentId[0] : info?.shipmentId;
                return id ?? "";
              })()
            }
            productList={tableData ?? []}
            editContext={componentEditContext}
            onAddComponents={() => {}}
            onComponentSaved={refetchProductDetailForTotals}
            onProductDeleted={() => {
              setProductId(null);
              createdProductSnapshotRef.current = null;
            }}
            onContinue={async (components) => {
              await refetchProductDetailForTotals();
              setProductDerivedComponents(components || []);
              setComponentModalOpen(false);
              setComponentEditContext(null);
              setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
            }}
          />
        </>
      )}
    </>
  );
};

export default CertifiedProductsComponents;
